import TemplateAnimation from "./Common/TemplateAnimation";

import DataLandingPageIntro from "./Data/DataLandingPage";
import IloLandingPage from "./Data/ILO/ILOLandingPage";
import { DATA_INTRO_CORTEX } from "./Data/CORTEX/DataLandingPage";

import TCA_WORKFLOW from "./Data/ILO/TCA";
import ILO1_WORKFLOW from "./Data/ILO/ILO1";
import ILO2_WORKFLOW from "./Data/ILO/ILO2";

import DataLandingPageENG from "./Data/ENG/DataLandingPage";
import { ISNA_WORKFLOW } from "./Data/ENG/ISNA/ISNAWorkflow";
import { IEAM_WORKFLOW } from "./Data/ENG/IEAM/IEAMWorkflow";
import { INLCM_WORKFLOW } from "./Data/ENG/INLCM/INLCMWorkflow";

import connectWithDispatch from "src/Hooks/connectWithDispatch";
import * as appActions from "src/Actions/appActions";

import { AI_TWIN_WORKFLOW } from "src/Data/AI_TWIN/AiTwinWorkflow";

interface AppProps {
  currentPage: string;
  setCurrentPage: (value: string) => void;
  param?: string;
}

const App = (props: AppProps) => {
  const { currentPage } = props;

  const templates = [
    {
      page: "INTRO_0",
      type: "landing-page-template" as TemplateType,
      data: DataLandingPageIntro,
    },
    {
      page: "ILO_2",
      type: "landing-page-template" as TemplateType,
      data: IloLandingPage,
    },
    ...TCA_WORKFLOW,
    ...ILO1_WORKFLOW,
    ...ILO2_WORKFLOW,
    {
      page: "ENG_1",
      type: "landing-page-template" as TemplateType,
      data: DataLandingPageENG,
    },
    ...IEAM_WORKFLOW,
    ...ISNA_WORKFLOW,
    ...INLCM_WORKFLOW,
    {
      page: "CORTEX_1",
      type: "intro-template" as TemplateType,
      data: DATA_INTRO_CORTEX,
    },
    ...AI_TWIN_WORKFLOW,
  ];

  // useEffect(() => {
  //   if (param === "sound_to_sight") setCurrentPage(101);
  //   if (param === "transformer") setCurrentPage(201);
  // }, [param, setCurrentPage]);

  // useEffect(() => {
  //   const isNotTransformer =
  //     currentPage.substring(0, 3) === "ENG" ||
  //     currentPage.substring(0, 3) === "ILO" ||
  //     currentPage.substring(0, 5) === "TOPAZ" ||
  //     currentPage === "INTRO_0";

  //   if (isTopaz) setLocalPage("topazai");
  //   else {
  //     if (isNotTransformer) setLocalPage(currentPage);
  //     else setLocalPage("transformer");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPage]);

  return (
    <>
      <TemplateAnimation currentPage={currentPage} templates={templates} />
    </>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    currentPage: state.appReducer.currentPage,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setCurrentPage: appActions.setCurrentPage,
};

export default connectWithDispatch(App, mapStateToProps, mapDispatchToProps);
